import { formatDataTest } from '@/common/dataTest/DataTest';
import { useInDialog } from '@/common/dialog/DialogScopeContext';
import { TextField } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { useFormFieldDef } from '../hooks/useFormFieldDef';

export const NumberFormField = ({ fieldDef, prefix }) => {
  const { value, setValue, onBlur, error, helperText, label, disabled } = useFormFieldDef(fieldDef);
  const inDialog = useInDialog();

  return (
    <NumericFormat
      // render as MUI TextField
      customInput={TextField}

      // formatting options
      thousandSeparator
      decimalScale={fieldDef.decimalPrecision}
      fixedDecimalScale
      prefix={prefix}
      
      value={value ?? ''}
      onValueChange={(values) => {
        setValue(values.floatValue ?? '');
      }}

      // delegate blur & error/display props
      onBlur={onBlur}
      error={!disabled && error}
      helperText={helperText}
      label={label}
      disabled={disabled}
      data-test-id={formatDataTest(inDialog ? 'dialog' : 'main', 'form-field', fieldDef.displayName)}
    />
  );
};